import { render, staticRenderFns } from "./ColorsTable.vue?vue&type=template&id=4de28950&scoped=true"
import script from "./ColorsTable.vue?vue&type=script&lang=js"
export * from "./ColorsTable.vue?vue&type=script&lang=js"
import style0 from "./ColorsTable.vue?vue&type=style&index=0&id=4de28950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de28950",
  null
  
)

export default component.exports